import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMagicWand"><Path d="M18.95 5.05024L17.1115 9.50722L20.2373 13.1779L15.4303 12.8067L12.9052 16.9138L11.7729 12.2274L7.08643 11.095L11.1936 8.56992L10.8223 3.76294L14.493 6.88877L18.95 5.05024Z" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 20.5L11.4405 12.5596" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMagicWand;
